import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['normalView', 'compactView', 'section']; // Added section target

  connect() {
    const name = this.data.get("name");

    if (localStorage.getItem(name) === "compact") {
      this.applyCompactView();
    } else {
      this.applyNormalView();
    }
  }

  selectNormalView(event) {
    event.preventDefault();
    this.applyNormalView();
    this.savePreference("normal");
  }

  selectCompactView(event) {
    event.preventDefault();
    this.applyCompactView();
    this.savePreference("compact");
    this.showSwipeHint();
  }

  // Helper to apply Compact UI state
  applyCompactView() {
    this.compactViewTarget.classList.add("active");
    this.normalViewTarget.classList.remove("active");
    document.body.classList.add("process-compact-view");
    
    // Toggle section width
    if (this.hasSectionTarget) {
      // this.sectionTarget.classList.remove("small-width");
      this.sectionTarget.classList.add("compact-view-width");
    }
  }

  // Helper to apply Normal UI state
  applyNormalView() {
    this.compactViewTarget.classList.remove("active");
    this.normalViewTarget.classList.add("active");
    document.body.classList.remove("process-compact-view");

    // Toggle section width
    if (this.hasSectionTarget) {
      this.sectionTarget.classList.remove("compact-view-width");
    }
  }

  savePreference(view) {
    const name = this.data.get("name");
    localStorage.setItem(name, view);
  }

  showSwipeHint() {
  if (window.innerWidth > 768) return

  const compactContainer = document.querySelector('.compact-process-view')
  if (!compactContainer) return

  compactContainer.classList.add('show-swipe-hint')

  clearTimeout(this._swipeHintTimeout)
  this._swipeHintTimeout = setTimeout(() => {
    compactContainer.classList.remove('show-swipe-hint')
  }, 2500)
}

}